import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Card,
  CardBody,
  Col,
  Row,
} from "reactstrap";

import "react-toastify/dist/ReactToastify.css";

import { Form, Formik } from "formik";
import RavenFormikField from "components/Common/RavenFormikField";
import * as Yup from "yup";

//Import Common Component

import {
  getInitValue,
  getInitValueNull,
} from "components/Common/TableComponents/AgTable/CellRenderers/CellFunctions";
import {
  WarningModal
} from "components/Common/CombinedComponents";
//Translate
import { withTranslation } from "react-i18next";
import { doPaymentPost, getTransactionProvisionLinkedAmounts } from "store/actions";

class DoPaymentVoidOperation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      warningModal: false,
    }
    this.handleValidRecordSubmit = this.handleValidRecordSubmit.bind(this);
  }
  getCurrencyName(currencyNumericCode) {
    let array = this.props.currencyDefRecordList
      .filter(i => i.numericCode === currencyNumericCode)
      .map(x => x);

    if (array?.length) return array[0].currencyName;
    else return currencyNumericCode;
  }
  componentDidMount() {
    const {
      getTransactionProvisionLinkedAmounts
    } = this.props;
    const voidRecord = {
      merchantId: this.props.selectedDataList.subMerchantId,
      orderId: this.props.selectedDataList.orderId,
      paymentId: this.props.selectedDataList.paymentId,
      apiKey: this.props.recordListByMerchantGuid[0]?.apiKey,
      conversationId: this.props.randomString,
      language: "tr",
      amount: this.props.selectedDataList.f004,
      currencyCode: this.props.selectedDataList.f049,
      transactionType: "VOID"
    }
    const record = {
      orderId: this.props.selectedDataList.orderId,
      merchantId: this.props.selectedDataList.subMerchantId,
      guid: this.props.selectedDataList.guid
    }
    getTransactionProvisionLinkedAmounts(record)
    this.props.doPaymentSignVoid(voidRecord)

  }


  handleValidRecordSubmit = values => {
    if (this.props.recordListAmounts?.amount > 0) {
      this.setState({ warningMessage: this.props.t("refundedRegistrationsCannotBeCancelled") })
      setTimeout(() => this.setState({ warningModal: true }), 500)
    } else {
      const record = {
        orderId: values.orderId,
        merchantId: values.subMerchantId,
        conversationId: this.props.randomString,
        language: "tr",
        sign: this.props.recordListSign.sign,
        paymentId: values.paymentId,
        transactionDetails: {
          transactionType: "VOID",
          currencyCode: values.currencyCode,
          amount: values.f004
        }

      }
      const { doPayment } = this.props;
      doPayment(record);
      this.props.toggle();
    }

  };

  render() {
    const styles = {
      border: '2px solid rgba(0, 0, 0, 0.08)',
    };
    const { record } = this.props;
    const { warningModal, warningMessage } = this.state;

    return (
      <React.Fragment>
        <WarningModal
          warningMessage={warningMessage}
          show={warningModal}
          onCloseClick={() => this.setState({ warningModal: false })}
        />
        <Formik
          enableReinitialize={true}
          initialValues={{
            orderId: getInitValue(record, record.orderId),
            paymentId: getInitValue(record, record.paymentId),
            f038: getInitValue(record, record.f038),
            bankUniqueReferenceNumber: getInitValue(record, record.bankUniqueReferenceNumber),
            cardNo: getInitValueNull(record, record.cardNo),
            insertDateTime: getInitValueNull(record, record.insertDateTime),
            transactionCurrencyName: this.getCurrencyName(record.f049),
            currencyCode: getInitValue(record, record.f049),
            f004: getInitValueNull(record, record.f004),
            subMerchantId: getInitValue(record, record.subMerchantId),
            cancelDesc: getInitValue(record, record.cancelDesc)
          }}
          onSubmit={values => {
            this.handleValidRecordSubmit(values);
          }}
        >
          {({ errors, touched, setFieldValue }) => (
            <Form onChange={dirty => {
              this.setState({ isEditedValue: dirty });
            }}
            >

              <fieldset>
                <Row style={{ padding: "0" }}>
                  <Card style={styles}>
                    <CardBody>
                      <Row>
                        <Col lg={3} className="col-6">
                          <div className="mb-3">
                            <RavenFormikField
                              errors={errors}
                              touched={touched}
                              name={"orderId"}
                              label={this.props.t("orderId")}
                              type="text"
                              setFieldValue={setFieldValue}
                              disabled={true}
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <div className="mb-3">
                            <RavenFormikField
                              errors={errors}
                              touched={touched}
                              name={"paymentId"}
                              label={this.props.t("paymentId")}
                              type="text"
                              disabled={true}
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <div className="mb-3">
                            <RavenFormikField
                              errors={errors}
                              touched={touched}
                              name={"f038"}
                              label={this.props.t("authorizationNumber")}
                              type="text"
                              setFieldValue={setFieldValue}
                              disabled={true}
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <div className="mb-3">
                            <RavenFormikField
                              errors={errors}
                              touched={touched}
                              name={"bankUniqueReferenceNumber"}
                              label={this.props.t("bankUniqueReferenceNumber")}
                              type="text"
                              disabled={true}

                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={3} className="col-6">
                          <div className="mb-3">
                            <RavenFormikField
                              errors={errors}
                              touched={touched}
                              name={"cardNo"}
                              label={this.props.t("cardNumber")}
                              type="text"
                              disabled={true}
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <div className="mb-3">
                            <RavenFormikField
                              errors={errors}
                              touched={touched}
                              name={"insertDateTime"}
                              label={this.props.t("transactionDate")}
                              type="text"
                              disabled={true}
                            />
                          </div>
                        </Col>
                        <Col lg={3} className="col-6">
                          <div className="mb-3">
                            <RavenFormikField
                              errors={errors}
                              touched={touched}
                              name={"f004"}
                              label={this.props.t("transactionAmount")}
                              type="text"
                              disabled={true}
                            />
                          </div>
                        </Col>
                        <Col lg={3} className="col-6">
                          <div className="mb-3">
                            <RavenFormikField
                              errors={errors}
                              touched={touched}
                              name={"transactionCurrencyName"}
                              label={this.props.t("transactionCurrency")}
                              type="text"
                              disabled={true}
                            />
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Row>
                <Col lg={12}>
                  <div
                    style={{
                      textAlign: "right",
                    }}
                  >
                    <button
                      type="submit"
                      className="btn btn-success save-event"
                      style={{ marginRight: "3px" }}
                    >
                      {this.props.t("update")}
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary save-customer"
                      disabled={false}
                      onClick={() =>
                        this.props.toggle()
                      }
                    >
                      {this.props.t("cancel")}
                    </button>
                  </div>
                </Col>
              </fieldset>
            </Form>
          )}
        </Formik></React.Fragment>

    )
  }
}
DoPaymentVoidOperation.propTypes = {
  record: PropTypes.any,
  recordList: PropTypes.array,
  className: PropTypes.any,
  apiError: PropTypes.any,
  error: PropTypes.any,
  t: PropTypes.any,
  currencyDefRecordList: PropTypes.any,
  isDetail: PropTypes.any,
  toggle: PropTypes.any,
  recordCompanyTypeDefList: PropTypes.array,
  doPayment: PropTypes.func,
  recordListByMerchantGuid: PropTypes.any,
  recordListSign: PropTypes.any,
  randomString: PropTypes.any,
  selectedDataList: PropTypes.any,
  doPaymentSignVoid: PropTypes.any,
  getTransactionProvisionLinkedAmounts: PropTypes.func,
  recordListAmounts: PropTypes.array
};

const mapStateToProps = ({ doPayment, transactionProvision }) => ({
  recordList: doPayment.recordList,
  recordListAmounts: transactionProvision.recordListAmount,

});

const mapDispatchToProps = dispatch => ({
  doPayment: (record) => dispatch(doPaymentPost(record)),
  getTransactionProvisionLinkedAmounts: (record) => dispatch(getTransactionProvisionLinkedAmounts(record)),

});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(DoPaymentVoidOperation));